(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["saintmagic-collection-countdown"] && !Shopify.designMode) return;
  try {
    (() => {
    const start = () => {
      document.querySelectorAll('[data-sm-collection-countdown]').forEach(timer => {
        if (timer.dataset.initialized) return;
        timer.dataset.initialized = 'true';
        const locale = timer.dataset.locale || document.documentElement.lang || 'en';
        const year = Number(timer.dataset.year);
        const target = new Date(year, 9, 31);
        if (!Number.isFinite(target.getTime()) || Date.now() >= target.getTime()) return;
        const number = new Intl.NumberFormat(locale, { minimumIntegerDigits: 2, useGrouping: false });
        const nodes = Array.from(timer.querySelectorAll('[data-unit]')).map(node => {
          const format = new Intl.NumberFormat(locale, { style: 'unit', unit: node.dataset.unit, unitDisplay: 'narrow', useGrouping: false });
          return { node, format, value: node.querySelector('b'), label: node.querySelector('small') };
        });
        const date = new Intl.DateTimeFormat(locale, { month: 'long', day: 'numeric', year: 'numeric' }).format(target);
        timer.setAttribute('aria-label', date);
        timer.querySelector('time').setAttribute('aria-label', date);
        let interval;
        const update = () => {
          const remaining = Math.max(0, Math.floor((target.getTime() - Date.now()) / 1000));
          if (remaining === 0 || !timer.isConnected) {
            timer.hidden = true;
            if (interval) window.clearInterval(interval);
            return;
          }
          const values = [Math.floor(remaining / 86400), Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
          nodes.forEach(({ node, format, value, label }, index) => {
            const amount = values[index];
            value.textContent = number.format(amount);
            label.textContent = format.formatToParts(amount).filter(part => part.type === 'unit').map(part => part.value).join('');
            node.setAttribute('aria-label', format.format(amount));
          });
          timer.hidden = false;
        };
        update();
        if (!timer.hidden) interval = window.setInterval(update, 1000);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
    document.addEventListener('shopify:section:load', start);
  })();
  } catch(e) { console.error(e); }
})();

})();
